module.exports = __webpack_public_path__ + "img/calendarImg.e15a07f6.png";